import { createBrowserRouter } from "react-router-dom";
import Login from "./components/Login";
import ForgotPassword from "./components/ForgotPassword";
import Layout from "./components/Layout";
import Dashboard from "./screen/Dashboard";
import ProtectedRoute from "./api/ProtectedRoute";
import UserManagement from "./screen/UserManagement";
import ContentManagement from "./screen/ContentManagement";
import EvenetManagement from "./screen/EvenetManagement";
import CreateNewEvent from "./screen/CreateNewEvent";
import UserDetail from "./screen/UserDetail";
import EventDetail from "./screen/EventDetail";
import RolePermissionManagement from "./screen/RolePermissionManagement";
import AnalyticsManagement from "./screen/AnalyticsManagement";
import SettingsLogManagement from "./screen/SettingsLogManagement";
import AnnouncementManagement from "./screen/AnnouncementManagement";
import AdminProfile from "./screen/AdminProfile";
import AdminChangePassword from "./screen/AdminChangePassword";
import SupportManagement from "./screen/SupportManagement";
import FAQManagement from "./screen/FAQManagement";

const router = createBrowserRouter([
    {
        path: "/",
        element: <Login />
    },
    {
        path: "/forgot-password",
        element: <ForgotPassword />
    },
    {
        path: '/admin-dashboard',
        element: <Layout />,
        children: [
            {
                index: true,
                element: <ProtectedRoute element={< Dashboard />} />
            },
            {
                path: 'user-management',
                element: <ProtectedRoute element={<UserManagement />} />
            },
            {
                path: 'user-detail/:id',
                element: <ProtectedRoute element={<UserDetail />} />
            },
            {
                path: 'content-management',
                element: <ProtectedRoute element={<ContentManagement />} />
            },
            {
                path: 'event-and-challenge-management',
                element: <ProtectedRoute element={<EvenetManagement />} />
            },
            {
                path: 'create-new-event',
                element: <ProtectedRoute element={<CreateNewEvent />} />
            },
            {
                path: 'event-detail/:id',
                element: <ProtectedRoute element={<EventDetail />} />
            },
            {
                path: 'announcement-management',
                element: <ProtectedRoute element={<AnnouncementManagement />} />
            },
            {
                path: 'analytics-management',
                element: <ProtectedRoute element={<AnalyticsManagement />} />
            },
            {
                path: 'role-and-permission-management',
                element: <ProtectedRoute element={<RolePermissionManagement />} />
            },
            {
                path: 'settings-and-log-management',
                element: <ProtectedRoute element={<SettingsLogManagement />} />
            },
            {
                path: 'support-management',
                element: <ProtectedRoute element={<SupportManagement />} />
            },
            {
                path: 'faq-management',
                element: <ProtectedRoute element={<FAQManagement />} />
            },
            {
                path: 'profile',
                element: <ProtectedRoute element={<AdminProfile />} />
            },
            {
                path: 'reset-password',
                element: <ProtectedRoute element={<AdminChangePassword />} />
            },
        ]
    }
])

export default router;
